import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Printer } from "lucide-react";
import { Button } from "@/components/ui/button";
import { itDate } from "@/components/kit";
import { api } from "@/lib/api";

const th = "border border-[#94A3B8] px-2 py-1.5 text-left text-[11px] uppercase bg-[#EAF5F7]";
const td = "border border-[#94A3B8] px-2 py-1.5 align-top";

function Sheet({ title, sub, head, rows, testId }) {
  return (
    <section className="bg-white p-6 sm:p-8 rounded-xl border border-[#D4E6EC] print:border-0 print:p-0 print:break-after-page space-y-3" data-testid={testId}>
      <div><h2 className="font-serif-it text-3xl font-semibold">{title}</h2><div className="text-sm text-[#47606B]">{sub}</div></div>
      <table className="w-full text-sm border-collapse">
        <thead><tr>{head.map((h) => <th key={h} className={th}>{h}</th>)}</tr></thead>
        <tbody>{rows.map((r, i) => <tr key={i}>{r.map((v, j) => <td key={j} className={`${td} ${j === 0 ? "font-bold text-base" : ""}`}>{v}</td>)}</tr>)}</tbody>
      </table>
      {!rows.length && <div className="text-sm text-[#7B929C]">Nessun ospite con allergie o intolleranze nella lista.</div>}
    </section>
  );
}

export default function AllergySheet() {
  const { id } = useParams();
  const [c, setC] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/contracts/${id}`).then((r) => setC(r.data)).catch(() => setErr("Contratto non trovato"));
  }, [id]);
  if (err) return <div className="text-sm text-[#991B1B]" data-testid="allergy-error">{err}</div>;
  if (!c) return <div className="text-sm text-[#7B929C]">Caricamento…</div>;
  const d = c.data || {};
  const list = (c.guests || []).filter((g) => (g.allergie || "").trim());
  const byTable = [...list].sort((a, b) => (a.tavolo || "zz").localeCompare(b.tavolo || "zz", "it", { numeric: true }) || a.nome.localeCompare(b.nome, "it"));
  const byAllergy = [...list].sort((a, b) => a.allergie.localeCompare(b.allergie, "it") || a.nome.localeCompare(b.nome, "it"));
  const sub = `${d.evento_tipo || ""} di ${d.cliente_nome || ""} • ${itDate(d.evento_data)} • ${d.sede || ""} • ${list.length} ospiti con esigenze`;
  return (
    <div className="space-y-6 max-w-4xl mx-auto">
      <div className="flex justify-between items-center print:hidden">
        <Link to={`/contratti/${id}?tab=ospiti`} className="text-xs text-[#7B929C] inline-flex items-center gap-1" data-testid="allergy-back"><ArrowLeft size={13} /> Torna al contratto</Link>
        <Button className="rounded-full" onClick={() => window.print()} data-testid="allergy-print"><Printer size={15} className="mr-2" /> Stampa</Button>
      </div>
      <Sheet testId="allergy-kitchen" title="Cucina • Allergie e intolleranze" sub={sub} head={["Allergia / intolleranza", "Piatto alternativo", "Tavolo", "Ospite", "Menù"]}
        rows={byAllergy.map((g) => [g.allergie, g.alternativa || "DA DEFINIRE", g.tavolo || "—", g.nome, g.menu || ""])} />
      <Sheet testId="allergy-hall" title="Sala • Ospiti con esigenze per tavolo" sub={sub} head={["Tavolo", "Ospite", "Allergia / intolleranza", "Piatto alternativo"]}
        rows={byTable.map((g) => [g.tavolo || "—", g.nome, g.allergie, g.alternativa || "DA DEFINIRE"])} />
    </div>
  );
}
